import {isEmpty, pluralize, includes, filter, sortBy, createSelector} from 'helpers';
import {goal, details} from './goal';
import {sorting} from 'store/sorting';

const customOrder = createSelector(
  [ state => state.sortingInfo, goal ],
  ( sortingInfo, { id } ) => {
    const activities = sorting({ sortingInfo }, { module: 'activity' + id });
    const milestones = sorting({ sortingInfo }, { module: 'milestone' + id });
    if (!isEmpty(activities) || !isEmpty(milestones)) {
      return function customOrder(object) {
        return type(object) == 'activity' ? activities[object.id] : milestones[object.id];
      }
    }
  },
);

const preferences = createSelector(
  [ state => state.settings.goalPlan, customOrder ],
  ( preferences, customOrder ) => {
    preferences = {
      sort: 'newest',
      completed: 'milestones, activities',
      ...preferences,
    }
    return {
      ...preferences,
      sort: customOrder || (preferences.sort == 'newest' ? newest : oldest),
      filter: object => object.status != 'Completed' || includes(preferences.completed, pluralize(type(object))),
    }
  }
);

export const plan = createSelector(
  [ details, preferences ],
  ({ goal, activities, allActivities, milestones, ...details }, preferences) => goal && ({
    ...details,
    preferences,
    goal,
    activities: sortBy(filter(activities, preferences.filter), preferences.sort),
    milestones: sortBy(filter(milestones, preferences.filter), preferences.sort).map(milestone => ({
      ...milestone,
      activities: sortBy(filter(filter(allActivities, { goal_id: milestone.id }), preferences.filter), preferences.sort),
    })),
  })
);

function oldest({ ts, target_date }) {
  return ts || target_date || null;
}

function newest(props) {
  return -1*oldest(props);
}

function type({ goal_id }) {
  return goal_id ? 'activity' : 'milestone';
}
